import { useNavigate, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import BatchSummaryView from "@/components/BatchSummaryView";

export default function BatchSummaryPage() {
  const { batchId } = useParams();
  const navigate = useNavigate();

  return (
    <div data-testid="batch-summary-page">
      <button
        data-testid="back-to-batch"
        onClick={() => navigate(`/batches/${batchId}`)}
        className="mb-3 flex h-10 items-center gap-1 text-sm font-semibold text-muted-foreground transition-colors hover:text-foreground"
      >
        <ArrowLeft className="h-4 w-4" /> Batch detail
      </button>
      <h1 className="mb-4 font-heading text-2xl font-extrabold tracking-tight">Final Purchasing Summary</h1>
      <BatchSummaryView batchId={batchId} />
    </div>
  );
}
